export default __webpack_public_path__ + "static/pexels-michelangelo-buonarroti-4176543_-6ca5a4b989b746b1122256437ee9f0cc.jpg";